<template>
  <div style="overflow-y:scroll; max-height: 85vh;">
    <div class="row">
      <div class="col-md usersList">
        <b-card-group deck>
          <b-card no-body header-tag="header">
            <template v-slot:header>
              <div class="row" id="locHeader">
                <div class="col-2"></div>
                <div
                  class="col-7"
                  style="font-size:20px; padding-top:5px; padding-right: 0;"
                >Employees of {{currAdmin.location}}/{{currAdmin.department}}</div>
                <div class="col-1"></div>
                <div class="col-2 vertAlignHeader noPaddsLR" style="margin-top: 5px;">
                  <b-button
                    class="buttonStyleAdd"
                    variant="outline-primary"
                    v-on:click="openAdminEditScreen({})"
                  >
                    <b-icon icon="plus"></b-icon>Add User
                  </b-button>
                </div>
              </div>
            </template>

            <div v-if="loading">
              <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
            </div>
            <b-list-group v-if="allAdmins.length > 0 && !loading">
              <b-list-group-item v-for="(admin, index) in allAdmins" :key="'adm-set-' + index">
                <AdminSetting
                  :admin="admin"
                  :isOnline="admins.find(el => el.adminId == admin.id) ? true : false"
                  v-on:dbupdate="updateDbSettings"
                  v-on:edituser="openAdminEditScreen($event)"
                  :key="'adetail-' + index"
                />
              </b-list-group-item>
            </b-list-group>
            <b-list-group v-else>
              <div class="col-12" style="text-align: center; min-width: 8600px;">No Users</div>
            </b-list-group>
          </b-card>
        </b-card-group>
      </div>
      <!-- <div class="col-2"></div> -->
      <b-modal
        centered
        ref="EditingScreen"
        :title="`${saveMode == 'newUser' ? 'Add new user to ' : 'Edit user at'} ${locName[currAdmin.location]} ${depName[currAdmin.department]}`"
        @ok="ApplyEdit"
      >
        <AdminSettingForm
          :alladmins="allAdmins"
          :rolePool="rolesToAssign"
          :errAllow="errShow"
          :isNew="saveMode == 'newUser'"
          v-model="adminOnChange"
          v-on:setOk="adminChangeOk = $event"
        />

        <template #modal-footer="{ ok, cancel }">
          <div class="row" style="width: 100%">
            <div class="col-4" style="text-align: left; padding-left: 0;">
              <b-button
                class="deleteStyle"
                v-on:click="adminOnChange = Object.assign({}, adminOnChange, allAdmins.find(el => el.id == adminOnChange.id))"
                variant="outline-danger"
                v-b-modal.removeAdmModal
                v-if="saveMode != 'newUser'"
              >Remove</b-button>
            </div>

            <div class="col-8" style="text-align: right; padding-right: 0;">
              <b-button
                variant="success"
                @click="ok()"
                style="margin: 0 5px 0 5px;"
              >{{saveMode == "newUser" ? 'Add User' : 'Save Changes'}}</b-button>
              <b-button variant="secondary" @click="cancel()" style="margin: 0 5px 0 5px;">Cancel</b-button>
            </div>
          </div>
        </template>
      </b-modal>
      <b-modal
        id="removeAdmModal"
        centered
        title="Confirm user removing"
        ok-title="Confirm"
        @ok="removeUser()"
        cancel-title="Cancel"
      >
        <p
          class="my-4"
          style="color: darkred; font-size: 21px;"
        >You are about to remove {{adminOnChange.userOptionalName || adminOnChange.user_google_name}} ({{adminOnChange.email}})</p>
        <p>Are you sure about that?</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import AdminSetting from "./SettingsComponents/AdminSetting.vue";
import AdminSettingForm from "./SettingsComponents/AdminSettingForm.vue";

export default {
  name: "Settings",
  components: {
    AdminSetting,
    AdminSettingForm
  },
  props: {
    currAdmin: Object,
    admins: Array
  },
  data() {
    return {
      allAdmins: [],
      adminOnChange: {},
      adminChangeOk: false,
      saveMode: "",
      errShow: false,
      windowHeight: 500,
      loading: true,
      locName: {
        londonderrydodge: "Londonderry Dodge",
        northsidemitsubishi: "NorthSide Mitsubishi",
        lanissan: "LaNissan",
        lamazda: "LaMazda",
        northsidenissan: "NorthSide Nissan",
        rivercityhyundai: "Rivercity Hyundai",
        sherwoodkia: "Sherwood Kia",
        sherwoodnissan: "Sherwood Nissan"
      },
      depName: { service: "Service", sales: "Sales" },
      rolesToAssign: [
        { value: 1, text: "Admin" },
        { value: 2, text: "Manager" },
        { value: 3, text: "Appointment Coordinator" }
      ]
    };
  },
  created() {
    if (this.currAdmin.role >= 2) {
      this.rolesToAssign.splice(0, 2);
    }

    this.loadAllAdmins();
    this.makeWindowHeight();
  },

  methods: {
    updateDbSettings: function(v) {
      if (v.id) {
        firebase
          .firestore()
          .doc(`admins/${this.currAdmin.location}/adminsInfo/${v.id}`)
          .update(v.ftdata);
        if (this.admins.find(el => el.adminId == v.id)) {
          firebase
            .database()
            .ref(`adminsOnline/${v.id}`)
            .update(v.dbdata);
        }
      }
    },

    openAdminEditScreen(admin) {
      if (Object.keys(admin).length == 0) {
        this.saveMode = "newUser";
        this.adminOnChange = Object.assign({}, this.adminOnChange, {
          name: "",
          email: "",
          role: null
        });
      } else {
        this.saveMode = "editUser";
        admin["name"] = admin.userOptionalName || admin.user_google_name;
        this.adminOnChange = Object.assign({}, this.adminOnChange, admin);
      }
      this.errShow = false;
      this.$refs["EditingScreen"].show();
    },

    makeWindowHeight() {
      this.windowHeight = window.innerHeight;
    },

    removeUser() {
      let that = this;

      firebase
        .firestore()
        .doc(
          `admins/${this.currAdmin.location}/adminsInfo/${this.adminOnChange.id}`
        )
        .delete()
        .then(function() {
          let ind = that.allAdmins.findIndex(
            el => el.id == that.adminOnChange.id
          );
          if (ind > -1) {
            that.allAdmins.splice(ind, 1);
          }
        })
        .catch(function() {
          alert("Oops... Something went wrong. User was not removed");
        });

      this.$refs["EditingScreen"].hide();
    },

    uigen() {
      return (
        "u" +
        Math.random()
          .toString(36)
          .substr(2, 9)
      );
    },

    ApplyEdit(bvModalEvt) {
      if (!this.adminChangeOk) {
        bvModalEvt.preventDefault();
        this.errShow = true;
      } else {
        let updObj = new Object();
        if (this.saveMode == "newUser") {
          updObj = {
            user_google_name: this.adminOnChange.name,
            email: this.adminOnChange.email.toLowerCase(),
            role: this.adminOnChange.role,
            fbId: "",
            googleId: "",
            id: this.uigen() + this.uigen(),
            loggedIn: false,
            status: "offline",
            url_pict: "",
            chatRoute: false,
            notificationsToEmail: "",
            showNotifications: true,
            userOptionalName: this.adminOnChange.name,
            department: this.currAdmin.department,
            popupAllowed: false,
            transcriptToEmail: false,
            location: this.currAdmin.location
          };
        } else {
          updObj = {
            userOptionalName: this.adminOnChange.name,
            email: this.adminOnChange.email.toLowerCase(),
            role: this.adminOnChange.role,
            id: this.adminOnChange.id
          };
        }

        let that = this;
        firebase
          .firestore()
          .doc(`admins/${this.currAdmin.location}/adminsInfo/${updObj.id}`)
          .set(updObj, { merge: true })
          .then(() => {
            if (that.saveMode == "newUser") {
              this.allAdmins.push(updObj);
            } else {
              let ind = this.allAdmins.findIndex(el => el.id == updObj.id);
              if (ind > -1) {
                that.$set(
                  that.allAdmins[ind],
                  "userOptionalName",
                  that.adminOnChange.name
                );
                that.$set(
                  that.allAdmins[ind],
                  "email",
                  that.adminOnChange.email
                );
                that.$set(that.allAdmins[ind], "role", that.adminOnChange.role);
              }
            }
          });

        this.$refs["EditingScreen"].hide();
      }
    },

    loadAllAdmins() {
      let that = this;
      this.loading = true;

      firebase
        .firestore()
        .collection(`admins/${this.currAdmin.location}/adminsInfo`)
        .where("department", "==", this.currAdmin.department)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            if (doc.data().id && doc.data().role > that.currAdmin.role) {
              that.allAdmins.push(doc.data());
            }
          });
          that.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.buttonStyleAdd {
  padding: 3px 5px 0px 5px;
}
.deleteStyle {
  text-align: right;
  padding: 3px 5px 0px 5px;
}
.vertAlignHeader {
  line-height: 27px;
}

.usersList {
  overflow: auto;
  margin: auto;
  max-width: 1200px;
}

.noPaddsLR {
  padding-left: 0px;
  padding-right: 0px;
}
.nopad-left {
  padding-left: 0;
}

@media (max-width: 992px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 100%;
  }

  .usersList {
    max-width: 100%;
  }
}
</style>